import { render, staticRenderFns } from "./GraficoAcucarRastreabilidade.vue?vue&type=template&id=8b83e5e2&scoped=true&lang=pug"
import script from "./GraficoAcucarRastreabilidade.vue?vue&type=script&lang=js"
export * from "./GraficoAcucarRastreabilidade.vue?vue&type=script&lang=js"
import style0 from "./GraficoAcucarRastreabilidade.vue?vue&type=style&index=0&id=8b83e5e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b83e5e2",
  null
  
)

export default component.exports